/**
 * By default, align labels and tooltips to the right of the data of the data point, centered vertically.
 */
export const YC_DEFAULT_LABEL_ALIGNMENT = { x: 'right', y: '' };
/** A mapping of shape names returned from the backend
 *  to YCharts custom highcharts symbol names or Highcharts symbol names
 *  (See: scatter-plot-highcharts-app/highcharts/index.ts) */
export const YC_SHAPE_MAP_SCATTER_PLOT = {
    circle: 'circle',
    cross: 'ycCross',
    diamond: 'ycDiamond',
    triangle: 'ycTriangle',
};
/** A mapping of size names returned from the backend
 *  to the pixel radius of a Highcharts marker symbol */
export const YC_SIZE_MAP_SCATTER_PLOT = {
    small: 5,
    medium: 7,
    large: 10,
    extra_large: 12,
};
export const DEFAULT_SCATTER_PLOT_CUSTOM = {
    zoomed: false,
};
/**
 * The opacity of the scatter plot marker is 70%, or B3 in hexadecimal.
 * The last two digits of an 8 digit hex color string set the color's alpha channel, or in other words, its opacity.
 * This string is appended to the end of 6 digit hex color strings returned from the backend.
 */
export const SCATTER_PLOT_MARKER_OPACITY_HEX_STR = 'B3';
